/* Bildschutz (16.10.2026, Simon: «die Karten sollen nicht einfach gespeichert werden können»).
   Erschwert das Speichern aller Bilder der Website: kein Kontextmenü auf Bildern, kein Ziehen, kein Markieren.
   Langes Drücken auf iOS sperrt das CSS in theme.liquid (-webkit-touch-callout). Klicks, Tastatur, Scrollen
   und Zoomen bleiben unberührt. Bildschirmfotos und direkte Dateiadressen lassen sich im Web nicht verhindern. */
(() => {
  if (window.__gftBildschutz) return;
  window.__gftBildschutz = true;
  const BILD = 'img, picture, svg image, video, canvas, [data-gft-protect]';
  const istBild = el => el instanceof Element && !!el.closest(BILD);
  // Liegt unter dem Zeiger irgendwo ein Bild (auch unter einer Deckschicht oder in einem Link)?
  const bildUnterZeiger = (x, y) => {
    if (typeof x !== 'number' || !document.elementsFromPoint) return false;
    return document.elementsFromPoint(x, y).some(el => el.matches && el.matches(BILD));
  };
  document.addEventListener('contextmenu', e => {
    if (istBild(e.target) || bildUnterZeiger(e.clientX, e.clientY)) e.preventDefault();
  }, { capture: true });
  document.addEventListener('dragstart', e => {
    const t = e.target;
    if (istBild(t) || (t instanceof Element && t.querySelector && t.querySelector('img, picture'))) e.preventDefault();
  }, { capture: true });
  document.addEventListener('selectstart', e => {
    if (istBild(e.target)) e.preventDefault();
  }, { capture: true });
  const markieren = wurzel => {
    (wurzel.querySelectorAll ? wurzel : document).querySelectorAll('img:not([draggable])').forEach(img => img.setAttribute('draggable', 'false'));
  };
  const start = () => {
    markieren(document);
    new MutationObserver(m => m.forEach(r => r.addedNodes.forEach(n => {
      if (n.nodeType !== 1) return;
      if (n.tagName === 'IMG' && !n.hasAttribute('draggable')) n.setAttribute('draggable', 'false');
      else markieren(n);
    }))).observe(document.documentElement, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
